import { Form, Select } from 'antd';
import { RTL_LANGUAGES } from 'constants/translations';
import { FC, memo, useEffect, useState } from 'react';
import { fetchServices } from 'services/api/services';
import { ServiceListRow } from 'types/api/services';

interface IProps {
  lang?: string;
  disabled?: boolean;
}

const ServicesSelect: FC<IProps> = ({ lang, disabled }) => {
  const [services, setServices] = useState<ServiceListRow[]>([]);

  useEffect(() => {
    let cancelled = false;

    const load = async () => {
      try {
        const res = await fetchServices({
          page: 1,
          limit: 999,
          lang: lang ?? undefined
        });

        if (!cancelled) setServices(res.results);
      } catch {
        // swallow — empty options on failure
      }
    };

    load();

    return () => {
      cancelled = true;
    };
  }, [lang]);

  return (
    <Form.Item label="Services" name="services" rules={[{ required: false }]}>
      <Select
        direction={RTL_LANGUAGES.includes(lang as string) ? 'rtl' : 'ltr'}
        mode="multiple"
        optionFilterProp="children"
        filterOption={(input, option) =>
          option?.label.toLowerCase().includes(input.toLowerCase()) || false
        }
        filterSort={(optionA, optionB) =>
          optionA.label
            .toLowerCase()
            .localeCompare(optionB?.label.toLowerCase())
        }
        options={services.map(item => ({
          label: item.title,
          value: item.id
        }))}
        disabled={disabled}
      />
    </Form.Item>
  );
};

export default memo(ServicesSelect);
